import $ from 'jquery';
import Groups from 'portlets/site/showcase/groups/groups';
import Slides from 'portlets/site/showcase/slides/slides';

export default class {
	constructor(options) {
		const defaults = {
			el: '#showcase',
			dom: {
				groups: '#showcaseGroups',
				slides: '#showcaseSlides'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = [];
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$groups = this.$el.find(this.options.dom.groups);
		this.$slides = this.$el.find(this.options.dom.slides);
		return this;
	}

	setSlide(index, ancor) {
		this.slides.set(index);
		this.$el.data('params', [ancor]);
		this.$window.trigger('yota.router.check');
	}

	checkSlideChange() {
		return !this.slides.prevent;
	}

	update() {
		const params = this.$el.data('params') || [];
		let set = -1;
		if (params.length) {
			set = this.groups.setAncor(params[0]);
		}

		if (set >= 0) {
			this.slides.set(set, true);
		} else {
			const active = this.groups.getActive();
			if (active !== false) {
				this.$el.data('params', [active.ancor]);
			} else {
				this.slides.set(0, true);
				this.groups.setActive(0);
				this.update();
			}
			this.$window.trigger('yota.router.check');
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.groups = new Groups({
				el: this.$groups,
				callback: {
					set: this.setSlide.bind(this),
					check: this.checkSlideChange.bind(this)
				}
			}).render();
			this.slides = new Slides({
				el: this.$slides
			}).render();

			this.$el.on('yota.router.update', this.update.bind(this)).trigger('yota.router.update');
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/showcase/showcase.js